import styled, { css } from 'styled-components';

import Section from 'Elements/Section';

export const EventsSection = styled(Section)`
    ${({ theme }) => css`
        &&& {
            padding-top: 1rem;

            @media ${theme.breakpoints.large.media} {
                padding-top: 0;
                margin-top: -2rem;
            }
        }
    `}
`;
